import React, { createContext } from "react";

export const stateContext = createContext(null)
